exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-dropdown-menu.width50 .van-popup{width:50%}.van-dropdown-menu.width40 .van-popup{width:40%}.van-dropdown-menu.width60 .van-popup{width:60%}.van-dropdown-menu.isright .van-popup{left:auto;right:0}.van-dropdown-menu__bar{background-color:transparent!important}.van-dropdown-menu .van-dropdown-menu__title:after{display:none}.van-dropdown-menu__title,.van-dropdown-menu__title--active{color:#fff}.van-dropdown-menu__item{height:40px;line-height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56c63696","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/myMoreBtn.vue
// module id = 216
// module chunks = 0